// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudSyncOutlinedSvg from "@fishx/icons-svg/es/asn/CloudSyncOutlined";
import FishxIcon from '../components/FishxIcon';

var CloudSyncOutlined = function CloudSyncOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudSyncOutlinedSvg
  }));
};

CloudSyncOutlined.displayName = 'CloudSyncOutlined';
export default React.forwardRef(CloudSyncOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudSyncOutlined.js
// module id = 2258
// module chunks = 0